import Cookies from 'js-cookie';
import axios from 'axios';
import { logoutCookie } from './utils';

// Add a global response interceptor for session expiry handling
axios.interceptors.response.use(
  response => response,
  error => {
    // Check if the request is for login, registration, OTP, or subscription endpoints
    const isExcludedRequest = error.config && error.config.url && (
      // Login endpoints
      error.config.url.includes('/auth/sign_in.json') ||
      error.config.url.includes('/web_login_with_email') ||
      error.config.url.includes('/web_login_with_otp') ||
      error.config.url.includes('/web_resend_otp') ||
      error.config.url.includes('/social_login/sign_in') ||
      // Registration endpoints
      error.config.url.includes('/v1/providers/signup/basic-info') ||
      error.config.url.includes('/v1/providers/signup/business-info') ||
      error.config.url.includes('/v1/providers/signup/additional-info') ||
      error.config.url.includes('/social_login/sign_up') ||
      // OTP endpoints
      error.config.url.includes('/validate_user') ||
      error.config.url.includes('/resend_otp') ||
      error.config.url.includes('/validate_password_otp') ||
      error.config.url.includes('/providers/update_mobile_number_without_login') ||
      // Subscription endpoints
      error.config.url.includes('/upgrade_package')
    );

    if (
      error.response && 
      (error.response.status === 401 || error.response.status === 403) &&
      !isExcludedRequest
    ) {
      logoutCookie();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const API = {
	wsURL: `wss://staging-api.easybids.com/cable`,
	stripeId: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
	baseURL: process.env.REACT_APP_BASE_URL,
	options: {
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			'access-token': Cookies.get('access_token'),
			'uid': Cookies.get('uid'),
			'client': Cookies.get('client'),
			'is_provider': 'true',
		}
	},
	fileOptions: {
		headers: {
			'Content-Type': 'multipart/form-data',
			'access-token': Cookies.get('access_token'),
			'uid': Cookies.get('uid'),
			'client': Cookies.get('client'),
			'is_provider': 'true',
		}
	}
}
export default API;